// import { createSlice } from '@reduxjs/toolkit';
// import { fetchAccountGetData } from './accountthunk';

// const initialState = {
//   data: null,
//   loading: false,
//   error: null,
//   students: [],
// };

// const accountSlice = createSlice({
//   name: 'accountGetData',
//   initialState,
//   reducers: {
//     clearData: (state) => {
//       console.log('[accountSlice] clearData action triggered');
//       state.data = null;
//       state.error = null;
//     },
//   },
//   extraReducers: (builder) => {
//     builder
//       .addCase(fetchAccountGetData.pending, (state) => {
//         state.loading = true;
//         state.error = null;
//       })
//      .addCase(fetchAccountGetData.fulfilled, (state, action) => {
//         console.log("Raw payload:", action.payload); // Debug payload
//         state.loading = false;
//         state.data = action.payload;
//         if (action.payload?.accounts) {
//           state.students = Object.values(action.payload.accounts)
//             .filter(account => account?.account?.role === 'STUDENT')
//             .map(account => account.account);
//         } else {
//           console.warn("No accounts in payload");
//           state.students = [];
//         }
//         console.log("📦 Final students list:", state.students);
//       })
//       .addCase(fetchAccountGetData.rejected, (state, action) => {
//         state.loading = false;
//         state.error = action.error.message;
//       });
//   },
// });

// export const { clearData } = accountSlice.actions;
// export default accountSlice.reducer;

import { createSlice } from '@reduxjs/toolkit';
import { fetchAccountGetData } from './accountthunk';

const initialState = {
  data: null,
  loading: false,
  error: null,
  students: [],
  staff: [], // ✅ added staff array
};

const accountSlice = createSlice({
  name: 'accountGetData',
  initialState,
  reducers: {
    clearData: (state) => {
      console.log('[accountSlice] clearData action triggered');
      state.data = null;
      state.error = null;
      state.students = [];
      state.staff = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAccountGetData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAccountGetData.fulfilled, (state, action) => {
        console.log("Raw payload:", action.payload);
        state.loading = false;
        state.data = action.payload;

        if (action.payload?.accounts) {
          const accountsArray = Object.values(action.payload.accounts);

          // ✅ Filter STUDENTS
          state.students = accountsArray
            .filter(acc => acc?.account?.role === 'STUDENT')
            .map(acc => acc.account);

          // ✅ Filter STAFF
          state.staff = accountsArray
            .filter(acc => acc?.account?.role === 'STAFF')
            .map(acc => acc.account);

        } else {
          console.warn("No accounts in payload");
          state.students = [];
          state.staff = [];
        }

        console.log("📦 Students:", state.students);
        console.log("📦 Staff:", state.staff);
      })
      .addCase(fetchAccountGetData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export const { clearData } = accountSlice.actions;
export default accountSlice.reducer;